import React, { Component } from 'react'

export default class Codepen extends Component {
    render() {
        return (
            <React.Fragment>
                <p className="sichkovskyi__codepen-title text-center text-xl uppercase font-bold"><i className="fab fa-codepen mr-1"></i> Featured Pen</p>
                <iframe className="sichkovskyi__codepen-embed" scrolling="no" title="Zenduja Spinner" src="//codepen.io/filingroove/embed/zWQJzj/?theme-id=light&default-tab=result" frameBorder="no" allowtransparency="true" allowFullScreen={true}>
                See the Pen <a href='https://codepen.io/filingroove/pen/zWQJzj/'>Zenduja Spinner</a> by sichkovskyi
                (<a href='https://codepen.io/filingroove'>@filingroove</a>) on <a href='https://codepen.io'>CodePen</a>.
                </iframe>
            </React.Fragment>
        )
    }
}
